import { styled } from "../../../../../styles";

export const TooltipWrapper = styled("div", {
  backgroundColor: "#FFFFFF",
  border: "1px solid #D6D6D6",
  borderRadius: "8px",
  padding: "8px 12px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "12px",
  color: "#4B4B4B",
});

export const TooltipLabel = styled("div", {
  fontWeight: 600,
  marginBottom: "4px",
  color: "#212121",
});

export const TooltipRow = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

// Background colour is per-series, passed by Recharts; keep that as an inline
// `style={{ backgroundColor }}` on the rendered element rather than wiring 30+
// Stitches variants. Everything else (shape, size) is locked in here.
export const TooltipDot = styled("span", {
  display: "inline-block",
  width: "8px",
  height: "8px",
  borderRadius: "50%",
});
